const TASK_ENABLED = 1;
const BONUS_FIXED = 1;
const BONUS_RATE = 2;

function decimalText(value, digits = 2) {
  const number = Number(value);
  if (!Number.isFinite(number) || number < 0) return (0).toFixed(digits);
  return digits === 2 ? formatDecimal(value) : number.toFixed(digits);
}

function compactDecimal(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return '0';
  return formatDecimal(value);
}

function parseRules(rawRules) {
  if (!rawRules) return {};
  if (typeof rawRules === 'object') return rawRules;
  try {
    const parsed = JSON.parse(rawRules);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_) {
    return {};
  }
}

function depositTaskView(task) {
  if (!task || Number(task.enabled) !== TASK_ENABLED) return null;
  const validDays = Math.max(1, Number(task.validDays) || 1);
  let reward = '';
  if (Number(task.bonusMethod) === BONUS_FIXED) {
    reward = `达标奖励 ${decimalText(task.bonusAmount)} 元`;
  } else if (Number(task.bonusMethod) === BONUS_RATE) {
    reward = `按达标时累计充值金额的 ${compactDecimal(task.rewardRate)}% 奖励`;
  }
  const turnoverMultiplier = Number(task.turnoverMultiplier);
  return {
    type: 'deposit',
    tag: '充值任务',
    title: String(task.title || '好友充值有奖励'),
    details: [
      `好友注册后 ${validDays} 天内累计充值满 ${decimalText(task.accumulatedDepositAmount)} 元`,
      reward,
      turnoverMultiplier > 0 ? `奖励需完成 ${compactDecimal(task.turnoverMultiplier)} 倍流水` : '奖励无额外流水要求',
      '奖励发放至邀请人的中心钱包'
    ].filter(Boolean)
  };
}

// 每个场馆单独展示活动返利比例，不能使用场馆常规返水比例代替。
function betRateDetails(venues, availableVenues) {
  const names = new Map((Array.isArray(availableVenues) ? availableVenues : [])
    .map((venue) => [String(venue.id), String(venue.name || '').trim()]));
  return (Array.isArray(venues) ? venues : [])
    .filter((venue) => Number.isFinite(Number(venue?.rebateRate)) && Number(venue.rebateRate) > 0)
    .map((venue) => {
      const name = names.get(String(venue.venueId)) || String(venue.venueName || '').trim();
      return {
        name: name || '参与场馆（名称暂不可用）',
        rate: `${compactDecimal(venue.rebateRate)}%`
      };
    });
}

function betTaskView(task, availableVenues) {
  if (!task || Number(task.enabled) !== TASK_ENABLED) return null;
  const validDays = Math.max(1, Number(task.validDays) || 1);
  const startTime = String(task.rebateStartTime || '').trim();
  const period = startTime
    ? `自 ${startTime} 起 ${validDays} 天内的已结算有效投注`
    : `任务开启后 ${validDays} 天内的已结算有效投注`;
  return {
    type: 'bet',
    tag: '投注任务',
    title: String(task.title || '好友投注享返利'),
    venues: betRateDetails(task.venues, availableVenues),
    minimumThreshold: Number(task.minimumRebateAmount) > 0 ? `${decimalText(task.minimumRebateAmount)} 元` : '不设最低门槛',
    maximumReward: `${decimalText(task.maximumRebateAmountPerFriend)} 元`,
    thresholdHint: Number(task.minimumRebateAmount) > 0 ? '累计返利达到门槛后发放' : '产生可发放的返利后发放',
    details: [
      period,
      '奖励发放至邀请人的中心钱包'
    ].filter(Boolean)
  };
}

// 只把后台任务规则中与会员参与直接相关的字段转成公开文案。
export function parseInvitationTasks(rawRules, availableVenues = []) {
  const rules = parseRules(rawRules);
  return [depositTaskView(rules.depositTask), betTaskView(rules.betTask, availableVenues)].filter(Boolean);
}
import { formatDecimal } from './formatDecimal.js';
